import { useEffect, useState } from 'react';
import instance from '../api/axios/utils.ts/instance';
import { ApiResponse } from '../constants/types';
import { CommunityLink } from './useCommunityLinks';

// 코스 찾기 링크 (커뮤니티 링크와 같은 구조, 노출 순서대로 내려온다)
export type CourseFinderLink = CommunityLink;

// 조회 실패 또는 빈 응답일 때 사용하는 기본 링크 (어드민 등록 데이터 기준, 경로·이미지는 로컬)
const FALLBACK_LINKS: CourseFinderLink[] = [
  {
    id: -1,
    name: '영어교실',
    description: '자녀와 함께하는',
    linkUrl: '/courses/homeschool',
    iconImageUrl: process.env.PUBLIC_URL + 'images/course/homeschool.png',
  },
  {
    id: -2,
    name: '주일학교 코스',
    description: '우리 교회를 위한',
    linkUrl: '/courses/churchschool',
    iconImageUrl: process.env.PUBLIC_URL + 'images/course/churchschool.png',
  },
  {
    id: -3,
    name: '소그룹 코스',
    description: 'NIV, 전도용',
    linkUrl: '/courses/smallgroup',
    iconImageUrl: process.env.PUBLIC_URL + 'images/course/selfstudy.png',
  },
];

// 헤더(PC/모바일)와 페이지가 동시에 써도 한 번만 호출한다. 실패하면 다음 마운트 때 재시도.
let request: Promise<CourseFinderLink[]> | null = null;

const fetchLinks = () => {
  if (!request) {
    request = instance
      .get<ApiResponse<CourseFinderLink[]>>('/v1/course-finder-links')
      .then(({ data }) => data.data ?? [])
      .catch((err) => {
        request = null;
        throw err;
      });
  }
  return request;
};

/**
 * 노출 중인 코스 찾기 링크 목록 조회
 * 조회가 끝났는데 목록이 비어 있으면 기본 링크로 폴백한다.
 */
export const useCourseFinderLinks = () => {
  const [links, setLinks] = useState<CourseFinderLink[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;

    fetchLinks()
      .then((data) => {
        if (alive) setLinks(data);
      })
      .catch((err) => console.error('코스 찾기 링크 조회 실패', err))
      .finally(() => {
        if (alive) setLoading(false);
      });

    return () => {
      alive = false;
    };
  }, []);

  return { links: !loading && !links.length ? FALLBACK_LINKS : links, loading };
};
